<div class="stat-row">
  <button type="button" class="stat-card" data-card="open" [class.active-filter]="isOpenActive()" (click)="onCardClick('open')">
    <div class="num">{{counts()?.openCases ?? '—'}}</div>
    <div class="lbl">{{'admin_support.lbl_stat_open' | translate}}</div>
  </button>
  <button type="button" class="stat-card" data-card="waiting" [class.active-filter]="statFilter() === 'waiting'" (click)="onCardClick('waiting')">
    <div class="num">{{counts()?.waitingOnUs ?? '—'}}</div>
    <div class="lbl">{{'admin_support.lbl_stat_waiting' | translate}}</div>
  </button>
  <button type="button" class="stat-card" data-card="new" [class.active-filter]="statFilter() === 'new'" (click)="onCardClick('new')">
    <div class="num">{{counts()?.newCasesCount ?? '—'}}</div>
    <div class="lbl">{{'admin_support.lbl_stat_new' | translate}}</div>
  </button>
  <button type="button" class="stat-card" data-card="email" [class.active-filter]="statFilter() === 'email'" (click)="onCardClick('email')">
    <div class="num">{{counts()?.fromEmail ?? '—'}}</div>
    <div class="lbl">{{'admin_support.lbl_stat_email' | translate}}</div>
  </button>
  <button type="button" class="stat-card" data-card="webapp" [class.active-filter]="statFilter() === 'webapp'" (click)="onCardClick('webapp')">
    <div class="num">{{counts()?.fromWebApp ?? '—'}}</div>
    <div class="lbl">{{'admin_support.lbl_stat_webapp' | translate}}</div>
  </button>
</div>
